import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleCheckbox } from '@features/filter/static/filterUtil';

import { storeItemInGlobalFilter } from '@store/actions/FilterAction';

const OrderStage = () => {
	const dataList = [
		{ label: 'On Shipment', value: 'ON_SHIPMENT' },
		{ label: 'Production', value: 'RUNNING' },
		{ label: 'Shipment Completed', value: 'COMPLETED' },
		{ label: 'Pending - PI', value: 'PROFORMA_INVOICE' },
		{ label: 'Pending - SC', value: 'SALES_CONTRACT' }
	];
	const filterData = useSelector((store) => store.filterFieldStore);

	const dispatch = useDispatch();

	const renderDataList = () => {
		return dataList?.map((item) => {
			return (
				<div className="form-group" key={`filter_orderStage_${item.value}`}>
					<input
						type="checkbox"
						id={`orderStage_${item.value}`}
						name={`orderStage_${item.value}`}
						value={item.value}
						onChange={(e) => handleCheckbox(e, item.label)}
						checked={toggleCheckbox(
							filterData,
							'orderStatus',
							`orderStage_${item.value}`,
							item.value
						)}
					/>
					<label htmlFor={`orderStage_${item.value}`}>
						<span>{item.label}</span>
					</label>
				</div>
			);
		});
	};

	const handleCheckbox = (e, title) => {
		let { value, checked, name } = e.target;
		let data = {
			name: 'orderStatus',
			key: value,
			value: title,
			identifier: name,
			checked: checked
		};
		dispatch(storeItemInGlobalFilter(data));
	};

	return (
		<div className="card border-bottom">
			<div className="card-header" id="headingFive">
				<h5 className="mb-0">
					<button
						className="btn btn-link collapsed"
						data-toggle="collapse"
						data-target="#orderStage"
						aria-expanded="false"
						aria-controls="orderStage"
					>
						Order Stage
					</button>
				</h5>
			</div>

			<div id="orderStage" className="collapse" aria-labelledby="headingFive" data-parent="#accordion">
				<div className="card-body">
					<div className="custom-chekbox">{renderDataList()}</div>
				</div>
			</div>
		</div>
	);
};

export default OrderStage;
